import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CAMRoutingModule } from './cam.routing';
import { CamTabLayoutComponent } from './components/cam-tab-layout/cam-tab-layout.component';
import { CompanyManagementComponent } from './components/company-management/company-management.component';
import { TravelerDetailsComponent } from './components/traveler-details/traveler-details.component';
import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { MatIconModule } from '@angular/material/icon';
import { MenuNavExpandedComponent } from './components/menu-nav-expanded/menu-nav-expanded.component';
import { MenuNavTravelerComponent } from './components/menu-nav-traveler/menu-nav-traveler.component';
import { MatTreeModule } from '@angular/material/tree';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ManageTravelerComponent } from './components/manage-traveler/manage-traveler.component';
import { MenuNavListingComponent } from './components/menu-nav-listing/menu-nav-listing.component';
import { AddTravelerComponent } from './components/add-traveler/add-traveler.component';
import { PersonalInfoFormComponent } from './components/personal-info-form/personal-info-form.component';
import { CostCenterOverviewComponent } from './components/cost-center-overview/cost-center-overview.component';
import { CompanyDetailComponent } from './components/company-detail/company-detail.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ProjectDetailsComponent } from './components/project-details/project-details.component';
import { CamEmptyStateComponent } from './components/cam-empty-state/cam-empty-state.component';
import { DesignationComponent } from './components/designation/designation.component';
import { DepartmentComponent } from './components/department/department.component';
import { CorporateCardsComponent } from './components/corporate-cards/corporate-cards.component';
import { MatTableModule } from '@angular/material/table';
import { TravelerManagmentComponent } from './components/traveler-managment/traveler-managment.component';
import { BulkUploadDialogComponent } from './components/bulk-upload-dialog/bulk-upload-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SuccessfullyUploadedComponent } from './components/successfully-uploaded/successfully-uploaded.component';
import { ErrorUploadedComponent } from './components/error-uploaded/error-uploaded.component';
import { ContactDetailsFormComponent } from './components/contact-details-form/contact-details-form.component';
import { DocumentInfoFormComponent } from './components/document-info-form/document-info-form.component';
import { EmployeeDetailsFormComponent } from './components/employee-details-form/employee-details-form.component';
import { SavedCardsComponent } from './components/saved-cards/saved-cards.component';
import { EmergerencyContectFormComponent } from './components/emergerency-contect-form/emergerency-contect-form.component';
import { PreferencesFormComponent } from './components/preferences-form/preferences-form.component';
import { UploadedFilesDialogComponent } from './components/uploaded-files-dialog/uploaded-files-dialog.component';
import { ApprovalManagementComponent } from './components/approval-management/approval-management.component';
import { WorkflowsettingFormComponent } from './components/workflowsetting-form/workflowsetting-form.component';
import { ApprovalflowFormComponent } from './components/approvalflow-form/approvalflow-form.component';
import { ApprovalListingComponent } from './components/approval-listing/approval-listing.component';
import { DivisionDetailsComponent } from './components/division-details/division-details.component';
import { BranchInfoComponent } from './components/branch-info/branch-info.component';
import { SavedDependentsComponent } from './components/saved-dependents/saved-dependents.component';
import { DependentsFormComponent } from './components/dependents-form/dependents-form.component';
import { DateOfbirthComponent } from './components/date-ofbirth/date-ofbirth.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { ManagerDelegationComponent } from './components/manager-delegation/manager-delegation.component';
import { EmployeegradeComponent } from './components/employeegrade/employeegrade.component';
import { TravelCategoryComponent } from './components/travel-category/travel-category.component';
import { PreDefinedReasonsComponent } from './components/pre-defined-reasons/pre-defined-reasons.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AddPassportDetailsComponent } from './components/add-passport-details/add-passport-details.component';
import { BusinessUnitOverviewComponent } from './components/business-unit-overview/business-unit-overview.component';
import { FlightPromoCodeComponent } from './components/flight-promo-code/flight-promo-code.component';
import { GenricFieldsComponent } from './components/genric-fields/genric-fields.component';
import { AddSupplierDialogComponent } from './components/add-supplier-dialog/add-supplier-dialog.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatChipsModule } from '@angular/material/chips';
import { AddOtherPreferenceDialogComponent } from './components/add-other-preference-dialog/add-other-preference-dialog.component';
import { ManagerDelegationSettingsComponent } from './components/manager-delegation-settings/manager-delegation-settings.component';
import { ReportingManagerTravelerComponent } from './components/reporting-manager-traveler/reporting-manager-traveler.component';
import { ApproversComponent } from './components/approvers/approvers.component';
import { DelegationComponent } from './components/delegation/delegation.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CompanySettingsComponent } from './components/company-settings/company-settings.component';
import { FaqsSettingsComponent } from './components/faqs-settings/faqs-settings.component';
import { MultiTravelerManagmentComponent } from './components/multi-traveler-managment/multi-traveler-managment.component';
import { EditDivisionDialogComponent } from './components/edit-division-dialog/edit-division-dialog.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ExpiryDataCalendarComponent } from '../passenger/components/expiry-data-calendar/expiry-data-calendar.component';
import { CommonDisplayBinderPipe } from 'src/app/shared/pipes/common-display-binder.pipe';
import { PolicyManagementComponent } from './components/policy-management/policy-management.component';
import { PolicyConfigurationComponent } from './components/policy-configuration/policy-configuration.component';
import { PolicyCriteriaComponent } from './components/policy-criteria/policy-criteria.component';
import { UpgradePolicyComponent } from './components/upgrade-policy/upgrade-policy.component';
import { BookingQueueManagementComponent } from './components/booking-queue-management/booking-queue-management.component';
import { ExpiryDateComponent } from './components/expiry-date/expiry-date.component';
import { FilterTravellerComponent } from './components/filter-traveller/filter-traveller.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from "../../shared/shared.module";
import { EmptyStateComponent } from 'src/app/shared/components/empty-state/empty-state.component';
import { ToastMessageComponent } from "../../shared/components/toast-message/toast-message.component";
import { MatMenuModule } from '@angular/material/menu';
import { EnableCompanyLoginComponent } from './components/enable-company-login/enable-company-login.component';
import { OtpVerificationDialogComponent } from './components/otp-verification-dialog/otp-verification-dialog.component';
import { ChangeEmailDomainComponent } from './components/change-email-domain/change-email-domain.component';
import { DependentInformationFormComponent } from './components/dependent-information-form/dependent-information-form.component';
import { FamilyMemberManagementComponent } from './components/family-member-management/family-member-management.component';
import { UserDeactivateDialogComponent } from './components/user-deactivate-dialog/user-deactivate-dialog.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { NewTravelerFormComponent } from './components/new-traveler-form/new-traveler-form.component';
import { ChangeRuleComponent } from './components/change-rule/change-rule.component';
import { LoggedinDevicesComponent } from './components/loggedin-devices/loggedin-devices.component';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ValidationFailureDialogComponent } from './components/validation-failure-dialog/validation-failure-dialog.component';



@NgModule({
    declarations: [
    ],
    imports: [
        CommonModule,
        FormsModule,
        NgSelectModule,
        CAMRoutingModule,
        MatExpansionModule,
        MatIconModule,
        MatTreeModule,
        MatButtonModule,
        MatInputModule,
        MatMenuModule,
        MatSelectModule,
        MatRadioModule,
        MatCheckboxModule,
        MatTableModule,
        MatDialogModule,
        ReactiveFormsModule,
        MatDividerModule,
        MatFormFieldModule,
        MatAutocompleteModule,
        MatTabsModule,
        MatChipsModule,
        MatSlideToggleModule,
        MatProgressSpinnerModule,
        ExpiryDataCalendarComponent,
        SharedModule,
        EmptyStateComponent,
        ToastMessageComponent,
        MatTooltipModule,
        MatListModule,
        MatPaginatorModule,
        CamTabLayoutComponent,
        CompanyManagementComponent,
        TravelerDetailsComponent,
        MenuNavExpandedComponent,
        MenuNavTravelerComponent,
        ManageTravelerComponent,
        MenuNavListingComponent,
        AddTravelerComponent,
        PersonalInfoFormComponent,
        CostCenterOverviewComponent,
        CompanyDetailComponent,
        ProjectDetailsComponent,
        CamEmptyStateComponent,
        DesignationComponent,
        DepartmentComponent,
        CorporateCardsComponent,
        TravelerManagmentComponent,
        BulkUploadDialogComponent,
        ErrorUploadedComponent,
        UploadedFilesDialogComponent,
        ValidationFailureDialogComponent,
        SuccessfullyUploadedComponent,
        ContactDetailsFormComponent,
        DocumentInfoFormComponent,
        EmployeeDetailsFormComponent,
        SavedCardsComponent,
        EmergerencyContectFormComponent,
        PreferencesFormComponent,
        ApprovalManagementComponent,
        WorkflowsettingFormComponent,
        ApprovalflowFormComponent,
        ApprovalListingComponent,
        DivisionDetailsComponent,
        BranchInfoComponent,
        SavedDependentsComponent,
        DependentsFormComponent,
        DateOfbirthComponent,
        ManagerDelegationComponent,
        EmployeegradeComponent,
        TravelCategoryComponent,
        PreDefinedReasonsComponent,
        AddPassportDetailsComponent,
        BusinessUnitOverviewComponent,
        FlightPromoCodeComponent,
        GenricFieldsComponent,
        AddSupplierDialogComponent,
        AddOtherPreferenceDialogComponent,
        ManagerDelegationSettingsComponent,
        ReportingManagerTravelerComponent,
        ApproversComponent,
        DelegationComponent,
        CompanySettingsComponent,
        FaqsSettingsComponent,
        MultiTravelerManagmentComponent,
        EditDivisionDialogComponent,
        CommonDisplayBinderPipe,
        PolicyManagementComponent,
        PolicyConfigurationComponent,
        PolicyCriteriaComponent,
        UpgradePolicyComponent,
        BookingQueueManagementComponent,
        ExpiryDateComponent,
        FilterTravellerComponent,
        EnableCompanyLoginComponent,
        OtpVerificationDialogComponent,
        ChangeEmailDomainComponent,
        DependentInformationFormComponent,
        FamilyMemberManagementComponent,
        UserDeactivateDialogComponent,
        ChangePasswordComponent,
        NewTravelerFormComponent,
        ChangeRuleComponent,
        LoggedinDevicesComponent
    ],
    exports: [ExpiryDataCalendarComponent, ExpiryDateComponent]
})
export class CAMModule { }
